import { Navigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { useAdmin } from '../../hooks/useAdmin';
import { LoginPage } from './LoginPage';
import { MULTI_TENANT_ENABLED } from '../../config/features';

type Props = {
  children: React.ReactNode;
  adminOnly?: boolean;
};

export function ProtectedRoute({ children, adminOnly = false }: Props) {
  const { user, loading: authLoading, isAuthorized } = useAuth();
  const { isAdmin, isCustomer, loading: adminLoading } = useAdmin();

  const loading = authLoading || adminLoading;

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <div className="spinner"></div>
      </div>
    );
  }

  if (!user || !isAuthorized) {
    return <LoginPage />;
  }

  if (MULTI_TENANT_ENABLED && isCustomer) {
    return <Navigate to="/customer" replace />;
  }

  if (adminOnly && !isAdmin) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
